export function getProductList (type) {
    type = type || 'zh-CN'
    const textObj = {
        'en': [
            {series: 'TS', type: 'TS Cable & Pipe Sealing System'},
            {series: 'TSCS', type: 'TSCS Round Sealing Solution'},
            {series: 'TSKT', type: 'TSKT Sleeve'},
            {series: 'TDB & TDG', type: 'TDB & TDG Terminal Box & Cable Gland'}
        ],
        'zh-CN': [
            {series: 'TS', type: 'TS电缆与管道密封系统'},
            {series: 'TSCS', type: 'TSCS圆形密封系列'},
            {series: 'TSKT', type: 'TSKT止水套筒'},
            {series: 'TDB & TDG', type: 'TDB & TDG接线箱与格兰'}
        ]
    }
    return textObj[type]
}

export function getNewsList (type) {
    type = type || 'zh-CN'
    const textObj = {
        'en': ['TSCS Sealing Solution is successfully applied in Underground Power tunnel', 'TS sealing system is achieving the big success and progress in Chemical Market'],
        'zh-CN': ['TSCS密封系列成功应用于地下电力管沟', 'TS密封系统在化工领域取得重大成功']
    }
    return textObj[type]
}



//////////////////
// WEBPACK FOOTER
// ./static/data.js
// module id = null
// module chunks = 